export function CustomerCtrl (
  $rootScope,
  $scope,
  $state,
  $translate,
  ams_autoclubs,
  billedCustomers,
  biller_balance,
  biller_credit_balance,
  carfaxApi,
  companyMessages,
  contactMethods,
  customer,
  Customer,
  customerMessagesApi,
  customerSources,
  events,
  inheritorApi,
  inspections,
  invoices,
  jsonApi,
  messages,
  payments,
  paymentTerms,
  priceTypes,
  quotes,
  sessionObjAPI,
  states,
  statusTypes,
  taxGroups,
  ukPostcodeApi,
  vehicles,
  vvGarageApi
) {
  $scope.ams_autoclubs        = ams_autoclubs;
  $scope.billedCustomers      = billedCustomers;
  $scope.companyMessages      = companyMessages;
  $scope.contact_method_types = contactMethods;
  $scope.customerSources      = customerSources;
  $scope.events               = events;
  $scope.inspections          = inspections;
  $scope.invoices             = invoices;
  $scope.payments             = payments;
  $scope.paymentTerms         = paymentTerms;
  $scope.price_types          = priceTypes;
  $scope.quotes               = quotes;
  $scope.states               = states;
  $scope.statusTypes          = statusTypes;
  $scope.taxGroups            = taxGroups;
  $scope.vehicles             = vehicles;

  $scope.biller = {
    balance       : biller_balance,
    credit_balance: biller_credit_balance
  };

  $scope.customer = customer || {
    ams_autoclub         : sessionObjAPI.company().ams_rewards_settings.ams_default_autoclub,
    cash_or_account      : 'C',
    customer_limited     : false,
    customer_type        : 'I',
    default_payment_terms: sessionObjAPI.company().default_payment_terms,
    mobile               : jsonApi.getQueryParameters().mobile,
    price_type           : '1'
  };

  $scope.carfax   = carfaxApi;

  inheritorApi.inheritCtrl('CustomerLiteCtrl', $scope);

  $scope.addCustomerToVVGarage = function () {
    vvGarageApi.addCustomer($scope.customer)
    .then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.CUSTOMER_ADDED_TO_VV_GARAGE'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.createFromOtherBranch = function () {
    Customer.createCustomerFromOtherBranch(false)
    .then(results => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.CUSTOMER'), 'success');

      $state.go('app.customer', {
        id: results.customer.id
      });
    });
  };

  $scope.removeCustomerFromVVGarage = function () {
    vvGarageApi.deleteCustomer($scope.customer)
    .then(() => {
      messages.show($translate.instant('VV_GARAGE_SPACE.CUSTOMER_REMOVED_FROM_VV_GARAGE'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function (form) {
    if ($scope.customer.tax_group_id) {
      $scope.customer.tax_group_name = $scope.taxGroups.filter(group => group.id === $scope.customer.tax_group_id)[0].name;
    }

    $scope.customer.biller_id = $scope.customer.biller === ''
      ? null
      : $scope.customer.biller_id;

    $scope.Customer.save()
    .then(customer => {
      form.$setPristine();
      $scope.customer = customer;
      $scope.Customer = new Customer($scope.customer);

      if (
        $rootScope.Company.hasIntegration('vvgarage') &&
        !$scope.customer.vv_garage_customer_id &&
        (
          ( !$scope.customer.first_name && !$scope.customer.contact_first )
          || ( !$scope.customer.last_name&& !$scope.customer.contact_last )
          || !$scope.customer.mobile || !$scope.customer.mobile
        )
      ) {
        messages.show("Customer saved. However, One of the following fields is empty and the customer cannot be submitted to vvGarage: first name, last name (or contact 1 first name and contact 1 last name for a company) or mobile. Please make sure all these fields are filled in before re-submitting.", 'warning');
      }
      else {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.CUSTOMER'), 'success');
      }

      customerMessagesApi.refreshCustomerSmsLogs();

      $state.go('app.customer', {
        id: $scope.customer.id
      }, {
        reload: true
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.searchUKPostcode = function (type = 'customer') {
    ukPostcodeApi.search(type === 'customer' ? $scope.customer.postcode : $scope.customer.postal_postcode)
    .then(data => {
      switch (type) {
        case 'postal':
          $scope.customer.postal_address1 = data.Premises;
          $scope.customer.postal_address2 = data.Street;
          $scope.customer.postal_suburb   = data.PostTown;
          $scope.customer.postal_postcode = data.Postcode;
          break;
        case 'customer':
        default:
          $scope.customer.address1 = data.Premises;
          $scope.customer.address2 = data.Street;
          $scope.customer.suburb   = data.PostTown;
          $scope.customer.postcode = data.Postcode;
          break;
      }

      messages.show($translate.instant('CUSTOMER_SPACE.CUSTOMER_ADDRESS_UPDATED'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };
}
